import axios from "axios";
export interface Category {
    id?: string;
    name: string;
}


export async function fetchCategories(): Promise<Category[]> {
    const response = await axios.get("/Category/get");
    return response.data;
}
